export const SALON_DETAILS_REQUEST = 'SALON_DETAILS_REQUEST';
export const SALON_DETAILS_SUCCESS = 'SALON_DETAILS_SUCCESS';
export const SALON_DETAILS_FAILURE = 'SALON_DETAILS_FAILURE';
export const GET_SERVICES_REQUEST = 'GET_SERVICES_REQUEST';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_FAILURE = 'GET_SERVICES_FAILURE';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const CLEAR_SELECTED_SERVICES = 'CLEAR_SELECTED_SERVICES';
export const GET_BOOKING_AVAILABILITY_REQUEST = 'GET_BOOKING_AVAILABILITY_REQUEST';
export const GET_BOOKING_AVAILABILITY_SUCCESS = 'GET_BOOKING_AVAILABILITY_SUCCESS';
export const GET_BOOKING_AVAILABILITY_FAILURE = 'GET_BOOKING_AVAILABILITY_FAILURE';
export const GET_WEEKLY_AVAILABILITY_REQUEST = 'GET_WEEKLY_AVAILABILITY_REQUEST';
export const GET_WEEKLY_AVAILABILITY_SUCCESS = 'GET_WEEKLY_AVAILABILITY_SUCCESS';
export const GET_WEEKLY_AVAILABILITY_FAILURE = 'GET_WEEKLY_AVAILABILITY_FAILURE';
export const GET_PATCH_WEEKLY_AVAILABILITY_REQUEST = 'GET_PATCH_WEEKLY_AVAILABILITY_REQUEST';
export const GET_PATCH_WEEKLY_AVAILABILITY_SUCCESS = 'GET_PATCH_WEEKLY_AVAILABILITY_SUCCESS';
export const GET_PATCH_WEEKLY_AVAILABILITY_FAILURE = 'GET_PATCH_WEEKLY_AVAILABILITY_FAILURE';
export const GET_PATCH_AVAILABILITY_REQUEST = 'GET_PATCH_AVAILABILITY_REQUEST';
export const GET_PATCH_AVAILABILITY_SUCCESS = 'GET_PATCH_AVAILABILITY_SUCCESS';
export const GET_PATCH_AVAILABILITY_FAILURE = 'GET_PATCH_AVAILABILITY_FAILURE';
export const SET_PATCH_TIME = 'SET_PATCH_TIME';
export const SET_APPOINTMENT_TIME = 'SET_APPOINTMENT_TIME';
export const SET_AVAILABILITY_SLOT = 'SET_AVAILABILITY_SLOT';
export const CLEAR_AVAILABLE_SLOTS = 'CLEAR_AVAILABLE_SLOTS';
export const CLEAR_AVAILABLE_DAYS = 'CLEAR_AVAILABLE_DAYS';
export const SET_SELECTED_STYLISTS = 'SET_SELECTED_STYLISTS';
export const CLEAR_SELECTED_STYLISTS = 'CLEAR_SELECTED_STYLISTS';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';
export const UPDATE_CLIENT_NAME = 'UPDATE_CLIENT_NAME';
export const UPDATE_CLIENT_EMAIL = 'UPDATE_CLIENT_EMAIL';
export const UPDATE_CLIENT_PHONE = 'UPDATE_CLIENT_PHONE';
export const UPDATE_FIRST_AVAILABLE_DATE = 'UPDATE_FIRST_AVAILABLE_DATE';
export const UPDATE_FIRST_AVAILABLE_PATCH_DATE = 'UPDATE_FIRST_AVAILABLE_PATCH_DATE';
export const SEND_BOOKING_DATA_REQUEST = 'SEND_BOOKING_DATA_REQUEST';
export const SEND_BOOKING_DATA_SUCCESS = 'SEND_BOOKING_DATA_SUCCESS';
export const SEND_BOOKING_DATA_FAILURE = 'SEND_BOOKING_DATA_FAILURE';
export const SEND_PATCH_TEST_BOOKING_DATA_REQUEST = 'SEND_PATCH_TEST_BOOKING_DATA_REQUEST';
export const SEND_PATCH_TEST_BOOKING_DATA_SUCCESS = 'SEND_PATCH_TEST_BOOKING_DATA_SUCCESS';
export const SEND_PATCH_TEST_BOOKING_DATA_FAILURE = 'SEND_PATCH_TEST_BOOKING_DATA_FAILURE';
export const CLEAR_SELECTED_PATCH_TIME = 'CLEAR_SELECTED_PATCH_TIME';
export const CLEAR_SELECTED_APPOINTMENT_TIME = 'CLEAR_SELECTED_APPOINTMENT_TIME';
export const GET_STYLISTS_FOR_SERVICE_REQUEST = 'GET_STYLISTS_FOR_SERVICE_REQUEST';
export const GET_STYLISTS_FOR_SERVICE_SUCCESS = 'GET_STYLISTS_FOR_SERVICE_SUCCESS';
export const GET_STYLISTS_FOR_SERVICE_FAILURE = 'GET_STYLISTS_FOR_SERVICE_FAILURE';
export const CLEAR_AVAILABLE_STYLISTS = 'CLEAR_AVAILABLE_STYLISTS';
export const SET_SERVICES_TO_SHOW = 'SET_SERVICES_TO_SHOW';
export const CLEAR_SERVICES_TO_SHOW = 'CLEAR_SERVICES_TO_SHOW';
export const GET_RECOMMENDED_SERVICES_REQUEST = 'GET_RECOMMENDED_SERVICES_REQUEST';
export const GET_RECOMMENDED_SERVICES_SUCCESS = 'GET_RECOMMENDED_SERVICES_SUCCESS';
export const GET_RECOMMENDED_SERVICES_FAILURE = 'GET_RECOMMENDED_SERVICES_FAILURE';
export const GET_STYLISTS_FOR_SERVICE_WEEKLY_REQUEST = 'GET_STYLISTS_FOR_SERVICE_WEEKLY_REQUEST';
export const GET_STYLISTS_FOR_SERVICE_WEEKLY_SUCCESS = 'GET_STYLISTS_FOR_SERVICE_WEEKLY_SUCCESS';
export const GET_STYLISTS_FOR_SERVICE_WEEKLY_FAILURE = 'GET_STYLISTS_FOR_SERVICE_WEEKLY_FAILURE';
export const SET_SERVICES_TO_BOOK = 'SET_SERVICES_TO_BOOK';
export const CLEAR_SERVICES_TO_BOOK = 'CLEAR_SERVICES_TO_BOOK';
export const SET_REFERRER = 'SET_REFERRER';
export const GET_CARD_DETAILS_REQUEST = 'GET_CARD_DETAILS_REQUEST';
export const GET_CARD_DETAILS_SUCCESS = 'GET_CARD_DETAILS_SUCCESS';
export const GET_CARD_DETAILS_FAILURE = 'GET_CARD_DETAILS_FAILURE';
export const CLEAR_USER_CARD_DETAILS = 'CLEAR_USER_CARD_DETAILS';
export const CLEAR_SALON_DETAILS = 'CLEAR_SALON_DETAILS';
export const SET_PAGE_VISITED = 'SET_PAGE_VISITED';
export const CLEAR_PAGE_VISITED = 'CLEAR_PAGE_VISITED';
export const SEARCH_QUERY_SERVICES = 'SEARCH_QUERY_SERVICES';
export const GET_CLIENT_DETAILS_REQUEST = 'GET_CLIENT_DETAILS_REQUEST';
export const GET_CLIENT_DETAILS_SUCCESS = 'GET_CLIENT_DETAILS_SUCCESS';
export const GET_CLIENT_DETAILS_FAILURE = 'GET_CLIENT_DETAILS_FAILURE';
export const GET_CLIENT_INVITES_REQUEST = 'GET_CLIENT_INVITES_REQUEST';
export const GET_CLIENT_INVITES_SUCCESS = 'GET_CLIENT_INVITES_SUCCESS';
export const GET_CLIENT_INVITES_FAILURE = 'GET_CLIENT_INVITES_FAILURE';
export const PROCCESS_INVITE_REQUEST = 'PROCCESS_INVITE_REQUEST';
export const PROCCESS_INVITE_SUCCESS = 'PROCCESS_INVITE_SUCCESS';
export const PROCCESS_INVITE_FAILURE = 'PROCCESS_INVITE_FAILURE';
export const SET_PAY_FULL_AMOUNT = 'SET_PAY_FULL_AMOUNT';
export const FETCH_APPOINTMENT_REQUEST = 'FETCH_APPOINTMENT_REQUEST';
export const FETCH_APPOINTMENT_SUCCESS = 'FETCH_APPOINTMENT_SUCCESS';
export const FETCH_APPOINTMENT_FAILURE = 'FETCH_APPOINTMENT_SUCCESS';
export const CONFIRM_EXTRA_AUTHENTICATION_REQUEST = 'CONFIRM_EXTRA_AUTHENTICATION_REQUEST';
export const CONFIRM_EXTRA_AUTHENTICATION_SUCCESS = 'CONFIRM_EXTRA_AUTHENTICATION_SUCCESS';
export const CONFIRM_EXTRA_AUTHENTICATION_FAILURE = 'CONFIRM_EXTRA_AUTHENTICATION_FAILURE';
export const CLEAR_PAYMENT_INTENT_ID = 'CLEAR_PAYMENT_INTENT_ID';
export const CLEAR_EXTRA_AUTHENTICATION_INFO = 'CLEAR_EXTRA_AUTHENTICATION_INFO';
export const SET_INVITE_POST_DATA = 'SET_INVITE_POST_DATA';
export const INVITATION_SENT = 'INVITATION_SENT';
export const GET_CLIENT_APPOINTMENTS_REQUEST = 'GET_CLIENT_APPOINTMENTS_REQUEST';
export const GET_CLIENT_APPOINTMENTS_SUCCESS = 'GET_CLIENT_APPOINTMENTS_SUCCESS';
export const GET_CLIENT_APPOINTMENTS_FAILURE = 'GET_CLIENT_APPOINTMENTS_FAILURE';
export const CANCEL_APPOINTMENT_REQUEST = 'CANCEL_APPOINTMENT_REQUEST';
export const CANCEL_APPOINTMENT_SUCCESS = 'CANCEL_APPOINTMENT_SUCCESS';
export const CANCEL_APPOINTMENT_FAILURE = 'CANCEL_APPOINTMENT_FAILURE';
export const CLEAR_CLIENT_APPOINTMENTS = 'CLEAR_CLIENT_APPOINTMENTS';
export const CHECK_WAITLIST_FOR_SERVICES_REQUEST = 'CHECK_WAITLIST_FOR_SERVICES_REQUEST';
export const CHECK_WAITLIST_FOR_SERVICES_SUCCESS = 'CHECK_WAITLIST_FOR_SERVICES_SUCCESS';
export const CHECK_WAITLIST_FOR_SERVICES_FAILURE = 'CHECK_WAITLIST_FOR_SERVICES_FAILURE';
export const CRUD_CARD_REQUEST = 'CRUD_CARD_REQUEST';
export const CRUD_CARD_SUCCESS = 'CRUD_CARD_SUCCESS';
export const CRUD_CARD_FAILURE = 'CRUD_CARD_FAILURE';
export const DELETE_CARD_REQUEST = 'DELETE_CARD_REQUEST';
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS';
export const DELETE_CARD_FAILURE = 'DELETE_CARD_SUCCESS';
export const SET_ADD_CARD_ERROR = 'SET_ADD_CARD_ERROR';
export const SET_SOHOW_ALL_AVAILABLE = 'SET_SOHOW_ALL_AVAILABLE';
export const GET_SALON_ONLINE_GROUP_REQUEST = 'GET_SALON_ONLINE_GROUP_REQUEST';
export const GET_SALON_ONLINE_GROUP_SUCCESS = 'GET_SALON_ONLINE_GROUP_SUCCESS';
export const GET_SALON_ONLINE_GROUP_FAILURE = 'GET_SALON_ONLINE_GROUP_FAILURE';
export const SET_UTM = 'SET_UTM';
export const CLEAR_AVAILABLE_PATCH_DAYS = 'CLEAR_AVAILABLE_PATCH_DAYS';
export const SET_GCLID = 'SET_GCLID';
